/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".create-campaign .mat-horizontal-content-container{overflow:unset}\n/*# sourceMappingURL=penalty-reward-campaign.component.css.map*/"];
export { styles as styles };
